import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { addFieldToGroup, changeFieldGroup, excludeFieldFromGroup } from '../helpers/groups'
import { useRearrangeFieldsMutation } from '../services/formField'
import { useActionType } from './useActionType'
import { useManageField } from './useManageFields'

export function useManageGroup() {
  const { formId } = useActionType()

  const { fields } = useManageField()

  const dispatch = useDispatch()

  const [rearrangeFields] = useRearrangeFieldsMutation()

  const updateFieldGroup = useCallback(
    async ({ fieldId, currentGroupId, targetGroupId }) => {
      let updatedFields = null

      if (targetGroupId && currentGroupId) {
        updatedFields = changeFieldGroup(fields, { fieldId, currentGroupId, targetGroupId })
      }

      if (targetGroupId && !currentGroupId) {
        updatedFields = addFieldToGroup(fields, { fieldId, targetGroupId })
      }

      if (!targetGroupId && currentGroupId) {
        updatedFields = excludeFieldFromGroup(fields, { fieldId, currentGroupId })
      }

      if (!updatedFields || !updatedFields.length) return

      await rearrangeFields({ formId, payload: updatedFields })
    },
    [fields, dispatch, formId]
  )

  return { updateFieldGroup }
}
